import * as React from 'react';

import { DescriptionPage_ProductVariant as ProductVariant } from '__generated__/graphql-types';

import SpecializationReviewsPageGuard from 'bundles/reviews/pages/specialization/SpecializationReviewsPageGuard';
import SpecializationReviewsExperimentProvider from 'bundles/unified-description-page-common/providers/specialization/SpecializationReviewsExperimentProvider';

type Props = {
  productVariant?: ProductVariant;
};

const SpecializationReviewsPageDirector = (props: Props) => (
  <SpecializationReviewsExperimentProvider>
    <SpecializationReviewsPageGuard {...props} />
  </SpecializationReviewsExperimentProvider>
);

export default SpecializationReviewsPageDirector;

export const ProfessionalCertificateReviewsPageDirector = () => (
  <SpecializationReviewsPageDirector productVariant={ProductVariant.ProfessionalCertificate} />
);
